import { staticColors } from '../../const/colors/staticColors';
import { pxToRem } from '../../helpers/rem';
export const textFontMap = {
    primary: 'Poppins',
    monospace: 'monospace',
};
export const textVariantStyleMap = {
    h1: {
        fontWeight: 600,
        fontSize: pxToRem(30),
        lineHeight: pxToRem(34),
    },
    h2: {
        fontWeight: 600,
        fontSize: pxToRem(26),
        lineHeight: pxToRem(30),
    },
    h3: {
        fontWeight: 600,
        fontSize: pxToRem(22),
        lineHeight: pxToRem(26),
    },
    h4: {
        fontWeight: 600,
        fontSize: pxToRem(18),
        lineHeight: pxToRem(22),
    },
    h5: {
        fontWeight: 600,
        fontSize: pxToRem(16),
        lineHeight: pxToRem(24),
    },
    h6: {
        fontWeight: 600,
        fontSize: pxToRem(14),
        lineHeight: pxToRem(21),
    },
    s1: {
        fontWeight: 500,
        fontSize: pxToRem(16),
        lineHeight: pxToRem(24),
    },
    s2: {
        fontWeight: 500,
        fontSize: pxToRem(14),
        lineHeight: pxToRem(21),
    },
    b1: {
        fontWeight: 400,
        fontSize: pxToRem(16),
        lineHeight: pxToRem(24),
    },
    b2: {
        fontWeight: 400,
        fontSize: pxToRem(14),
        lineHeight: pxToRem(21),
    },
    b3: {
        fontWeight: 400,
        fontSize: pxToRem(12),
        lineHeight: pxToRem(18),
    },
    button: {
        fontWeight: 600,
        fontSize: pxToRem(14),
        lineHeight: pxToRem(21),
        textTransform: 'uppercase',
    },
    caption: {
        fontWeight: 400,
        fontSize: pxToRem(12),
        lineHeight: pxToRem(16),
        textTransform: 'uppercase',
    },
};
export const textColorMap = {
    dark: staticColors.textDark,
    white: staticColors.textWhite,
    grey: staticColors.textGrey,
    lightGrey: staticColors.textLightGrey,
    danger: staticColors.textDanger,
    warning: staticColors.textWarning,
    action: staticColors.textAction,
    lightAction: staticColors.textLightAction,
    success: staticColors.textSuccess,
};
